import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Button from '../components/ui/Button';

const DynamicService = () => {
  const { slug } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);

  const createSlug = (text) => {
    return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  };

  useEffect(() => {
    const fetchService = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/services/`);
        const services = await response.json();
        
        const foundService = services.find(s => createSlug(s.title) === slug);
        
        if (foundService) {
          setService(foundService);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching service:', error);
        setLoading(false);
      }
    };

    fetchService();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-white lg:bg-cream">
        <Header />
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
        </div>
        <Footer />
      </div>
    );
  }

  if (!service) {
    return (
      <div className="min-h-screen bg-white lg:bg-cream">
        <Header />
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-text-primary mb-4">Service Not Found</h1>
            <p className="text-text-primary mb-8">The service you're looking for doesn't exist.</p>
            <Button variant="primary"><a href="/services">Back to Services</a></Button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white lg:bg-cream">
      <Header />
      
      <section className="py-20 bg-white lg:bg-cream">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {service.image && (
              <div>
                <img 
                  src={service.image.startsWith('http') ? service.image : `${process.env.REACT_APP_API_URL}${service.image}`}
                  alt={service.title}
                  className="w-full h-96 object-cover rounded-2xl shadow-lg"
                />
              </div>
            )}
            
            <div>
              <div className="text-sm font-semibold text-primary mb-3 uppercase tracking-wide">
                Service Details
              </div>
              <h1 className="text-4xl lg:text-5xl font-bold text-text-primary mb-6 leading-tight">
                {service.title}
              </h1>
              <p className="text-text-primary mb-6 text-lg leading-relaxed">
                {service.description}
              </p>
              
              <div className="flex flex-wrap gap-4">
                <Button variant="primary"><a href="/contact">Contact Us</a></Button>
                <Button variant="secondary"><a href="/services">View All Services</a></Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DynamicService;